import alt from 'alt'
import { createActions } from 'alt-utils/lib/decorators'
import { CheckSource, NotFoundCheckDetailSource } from 'sources'
import { CheckDetailActions, CheckActions } from 'actions'
import Enum from 'utils/Enum'

@createActions(alt)
export default class NotFoundCheckDetailActions {
  constructor() {
    // we rely on the CheckDetailActions and CheckActions stores and just update individual links here,
    //  setting the result by calling CheckDetailActions and CheckActions
  }

  fetchPaginatedMainBrokenLinks(page) {
    return NotFoundCheckDetailSource.fetchPaginatedMainBrokenLinks(page)
  }

  update(id, params) {
    return NotFoundCheckDetailSource.update(id, params)
      .then(result => {
        CheckDetailActions.fetched(result)
        CheckActions.updateCheckStatus({
          typeId: Enum.CheckTypes.notfound.id,
          verdict: result.verdict,
          verdictFriendly: result.verdictFriendly,
          executeResult: result.executeResult,
          exception: result.exception
        })
     })
  }

  fetchFullCheck() {
    return NotFoundCheckDetailSource.fetchFullCheck()
      .then(result => {
        CheckDetailActions.fetched(result)
        CheckActions.updateCheckStatus({
          typeId: Enum.CheckTypes.notfound.id,
          verdict: result.verdict,
          verdictFriendly: result.verdictFriendly,
          executeResult: result.executeResult,
          exception: result.exception
        })
     })
  }

  redirect(id, params) {
    return NotFoundCheckDetailSource.redirect(id, params)
      .then(result => {
        CheckDetailActions.fetched(result)
        CheckActions.updateCheckStatus({
          typeId: Enum.CheckTypes.notfound.id,
          verdict: result.verdict,
          verdictFriendly: result.verdictFriendly,
          executeResult: result.executeResult,
          exception: result.exception
        })
      })
  }

  updateRedirect(id, target) {
    return NotFoundCheckDetailSource.updateRedirect(id, target)
  }

  fetchRedirects() {
    return NotFoundCheckDetailSource.fetchRedirects()
  }

  fetchFreeBrokenLinkStatus() {
    return NotFoundCheckDetailSource.fetchFreeBrokenLinkStatus()
  }

  installFreeSnippet() {
    return NotFoundCheckDetailSource.installFreeSnippet()
  }
}



// WEBPACK FOOTER //
// ./app/actions/NotFoundCheckDetailActions.js